import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const formatData = (data, type = "trade") => {
    return data.map(item => {
        if (type === "trade") {
            return {
                ...item,
                Open_Time: item.Open_Time
                    ? item.Open_Time
                    : "",
            };
        }

        if (type === "live_trade") {
            return {
                ...item,
                Open_Time: item.Open_Time
                    ? item.Open_Time
                    : "",
            };
        }

        if (type === "transaction") {
            return {
                ...item,
                time: item.time
                    ? new Date(item.time * 1000).toLocaleString()
                    : "",
            };
        }

        if (type === "payment_transaction") {
            return {
                ...item,
                // ondate: item.ondate
                //     ? new Date(item.ondate * 1000).toLocaleString()
                //     : "",
            };
        }

        if (type === "demo_account" || type === "demo_accounts" || type === "demo") {
            const isExcludedKey = (k) => {
                const normalized = k.toLowerCase().replace(/[-_]/g, "");
                const excluded = [
                    "id",
                    "mid",
                    "nodesinpkcode",
                    "servername",
                    "isdelete",
                    "mpassword",
                    "ipassword",
                    "ftd",
                    "source",
                    "msg",
                    "msgcode",
                ];
                return excluded.includes(normalized);
            };

            const isLnameKey = (k) => {
                const normalized = k.toLowerCase().replace(/[-_]/g, "");
                return normalized === "lname" || normalized === "lastname";
            };

            const isValueEmpty = (val) => {
                if (val === null || val === undefined) return true;
                const s = String(val).trim();
                return (
                    s === "" ||
                    s.toLowerCase() === "null" ||
                    s.toLowerCase() === "undefined" ||
                    s.toLowerCase() === "none"
                );
            };

            const hasLnameKey = Object.keys(item).some(isLnameKey);
            const cleanedItem = {};
            let lnameAdded = false;

            for (const [key, value] of Object.entries(item)) {
                if (isExcludedKey(key)) {
                    continue;
                }

                if (isLnameKey(key)) {
                    cleanedItem[key] = isValueEmpty(value) ? "-" : value;
                    lnameAdded = true;
                } else {
                    cleanedItem[key] = value;
                    const norm = key.toLowerCase().replace(/[-_]/g, "");
                    if ((norm === "fname" || norm === "firstname") && !hasLnameKey) {
                        cleanedItem["lname"] = "-";
                        lnameAdded = true;
                    }
                }
            }

            if (!lnameAdded) {
                cleanedItem["lname"] = "-";
            }

            return cleanedItem;
        }
        return item;
    });
};

export const exportToExcel = (data, fileName = "data", type = "trade") => {
    if (!data || data.length === 0) return;

    const formattedData = formatData(data, type);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
};


// onClick = {() => { exportToExcel(tradeData, "trade_details") }}

// exportToExcel(transactionData, "account_transactions", "transaction");

// exportToExcel(tradeData, "trade_history", "trade");

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// // Excel export
// const formatTradeData = (data) => {
//     return data.map(trade => ({
//         ...trade,
//         Open_Time: trade.Open_Time
//             ? new Date(trade.Open_Time * 1000).toLocaleString()
//             : ""
//     }));
// };

// export const exportToExcel = (data, fileName = "data") => {
//     if (!data || data.length === 0) return;

//     const formattedData = formatTradeData(data);

//     const worksheet = XLSX.utils.json_to_sheet(formattedData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
// };